import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
  headers: { "Content-Type": "application/json" },
});

// Attach JWT token from localStorage if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // Récupérer la langue depuis localStorage (gérée par useI18n)
  const lang = localStorage.getItem("lang") || "fr";
  config.headers["Accept-Language"] = lang;

  return config;
});

// ── Markets ───────────────────────────────────────────────────────────────────
export const fetchMarkets   = (params = {}, lang) => api.get("/api/v1/evenements/markets/", { params: { ...params, lang } });
export const fetchMarket    = (id)          => api.get(`/api/v1/evenements/markets/${id}/`);
export const createMarket   = (data)        => api.post("/api/v1/evenements/markets/", data);
export const fetchMarketTrades    = (id)            => api.get(`/api/v1/evenements/markets/${id}/trades/`);
export const fetchMarketHistory   = (id, days = 30, endDate = null) => {
  const params = `days=${days}${endDate ? `&end_date=${endDate}` : ""}`;
  return api.get(`/api/v1/evenements/markets/${id}/history/?${params}`);
};
export const fetchMarketVolume    = (id, days = 14, endDate = null) => {
  const params = `days=${days}${endDate ? `&end_date=${endDate}` : ""}`;
  return api.get(`/api/v1/evenements/markets/${id}/volume_by_day/?${params}`);
};
// ── Trading ───────────────────────────────────────────────────────────────────
export const placeTrade = (marketId, payload) =>
  api.post(`/api/v1/evenements/markets/${marketId}/trade/`, payload);

// ── Positions ─────────────────────────────────────────────────────────────────
export const fetchMyPositions = () => api.get("/api/v1/evenements/markets/my_positions/");
export const fetchMyTrades    = (params = {}) => api.get("/api/v1/evenements/trades/", { params });

// ── Auth ──────────────────────────────────────────────────────────────────────
export const login  = (credentials) => api.post("/api/v1/evenements/auth/token/",         credentials);
export const signup = (data)        => api.post("/api/v1/evenements/auth/register/",      data);
export const refreshToken = (token) => api.post("/api/v1/evenements/auth/jwt/refresh/", { refresh: token });
export const verifyEmail  = (data) => api.post("/api/v1/evenements/auth/verify-email/",        data);
export const resendCode   = (data) => api.post("/api/v1/evenements/auth/verify-email/resend/",  data);
export const forgotPassword      = (data) => api.post("/api/v1/evenements/auth/password-forgot/",            data);
export const resetPasswordVerify = (data) => api.post("/api/v1/evenements/auth/password-reset/verify/",     data);
export const resetPasswordConfirm= (data) => api.post("/api/v1/evenements/auth/password-reset/confirm/",    data);

// ── Wallet ────────────────────────────────────────────────────────────────────
export const fetchWallet             = ()     => api.get("/api/v1/evenements/wallet/");
export const fetchDepositAddress     = (coin) => api.get(`/api/v1/evenements/wallet/deposit-address/?coin=${coin}`);
export const fetchTransactions       = (p={}) => api.get("/api/v1/evenements/wallet/transactions/", { params: p });
export const requestWithdrawal       = (data) => api.post("/api/v1/evenements/wallet/withdrawals/", data);
export const fetchWithdrawalRequests = ()     => api.get("/api/v1/evenements/wallet/withdrawals/");

export const requestCredit       = () => api.post("/api/v1/evenements/wallet/credit-request/");
export const getCreditStatus= ()     => api.get("/api/v1/evenements/wallet/credit-request/");
// ── Comments ──────────────────────────────────────────────────────────────────
export const fetchComments = (marketId, params={}) => api.get(`/api/v1/comments/markets/${marketId}/comments/`, { params });
export const postComment   = (marketId, data)       => api.post(`/api/v1/comments/markets/${marketId}/comments/`, data);
export const updateComment = (id, data)             => api.patch(`/api/v1/comments/comments/${id}/`, data);
export const deleteComment = (id)                   => api.delete(`/api/v1/comments/comments/${id}/`);
export const likeComment   = (id)                   => api.post(`/api/v1/comments/comments/${id}/like/`);

export const fetchMarketCategories = (params = {}) =>
  api.get("/api/v1/evenements/markets/categories/", { params });


export const fetchAnnouncements = () =>
  api.get("/api/v1/evenements/announcements/");

export const phoneStatus  = ()        => api.get("/api/v1/account/phone/status/");
export const phoneSendOTP = (phone)   => api.post("/api/v1/account/phone/send/", { phone_number: phone });
export const phoneVerify  = (phone, code) =>
  api.post("/api/v1/account/phone/verify/", { phone_number: phone, code });

export const fetchNotifications      = (params = {}) => api.get("/api/v1/account/notifications/inbox/", { params });
export const fetchUnreadCount        = ()             => api.get("/api/v1/account/notifications/unread-count/");
export const markNotificationRead    = (id)           => api.post(`/api/v1/account/notifications/${id}/read/`);
export const markAllNotificationsRead = ()             => api.post("/api/v1/account/notifications/read-all/");
 

export default api;